
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import Blog from '../pages/blog/page';
import CaseStudies from '../pages/case-studies/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';
import MortgageRefinance from '../pages/services/mortgage-refinance/page';
import PreunderwritingAI from '../pages/services/preunderwriting-ai/page';
import DebtSettlement from '../pages/services/debt-settlement/page';
import InboundCalls from '../pages/services/inbound-calls/page';
import HealthInsurance from '../pages/services/health-insurance/page';
import HomeSecurity from '../pages/services/home-security/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/services/mortgage-refinance',
    element: <MortgageRefinance />,
  },
  {
    path: '/services/preunderwriting-ai',
    element: <PreunderwritingAI />,
  },
  {
    path: '/services/debt-settlement',
    element: <DebtSettlement />,
  },
  {
    path: '/services/inbound-calls',
    element: <InboundCalls />,
  },
  {
    path: '/services/health-insurance',
    element: <HealthInsurance />,
  },
  {
    path: '/services/home-security',
    element: <HomeSecurity />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/case-studies',
    element: <CaseStudies />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
